import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconExport: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16968 10.0633C9.16812 10.0424 9.16732 10.0213 9.16732 10V3.33333C9.16732 2.87333 9.53982 2.5 10.0007 2.5C10.4615 2.5 10.834 2.87333 10.834 3.33333V9.99986L12.8339 8.50003C13.2023 8.22253 13.7248 8.29836 14.0006 8.6667C14.2773 9.03503 14.2023 9.55753 13.834 9.83336L10.5006 12.3334C10.3531 12.4442 10.1764 12.5 10.0006 12.5C9.83312 12.5 9.66562 12.4492 9.52145 12.3484L6.18812 10.0034C5.81145 9.73836 5.72062 9.21836 5.98562 8.84253C6.25062 8.46586 6.76978 8.37503 7.14645 8.64003L9.16968 10.0633ZM5.00065 14.1667V15H15.0007V14.1667C15.0007 13.7083 15.3757 13.3333 15.834 13.3333C16.2923 13.3333 16.6673 13.7083 16.6673 14.1667V15.8333C16.6673 16.2917 16.2923 16.6667 15.834 16.6667H4.16732C3.70898 16.6667 3.33398 16.2917 3.33398 15.8333V14.1667C3.33398 13.7083 3.70898 13.3333 4.16732 13.3333C4.62565 13.3333 5.00065 13.7083 5.00065 14.1667Z"
        fill={fill}
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="14"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16968 10.0633C9.16812 10.0424 9.16732 10.0213 9.16732 10V3.33333C9.16732 2.87333 9.53982 2.5 10.0007 2.5C10.4615 2.5 10.834 2.87333 10.834 3.33333V9.99986L12.8339 8.50003C13.2023 8.22253 13.7248 8.29836 14.0006 8.6667C14.2773 9.03503 14.2023 9.55753 13.834 9.83336L10.5006 12.3334C10.3531 12.4442 10.1764 12.5 10.0006 12.5C9.83312 12.5 9.66562 12.4492 9.52145 12.3484L6.18812 10.0034C5.81145 9.73836 5.72062 9.21836 5.98562 8.84253C6.25062 8.46586 6.76978 8.37503 7.14645 8.64003L9.16968 10.0633ZM5.00065 14.1667V15H15.0007V14.1667C15.0007 13.7083 15.3757 13.3333 15.834 13.3333C16.2923 13.3333 16.6673 13.7083 16.6673 14.1667V15.8333C16.6673 16.2917 16.2923 16.6667 15.834 16.6667H4.16732C3.70898 16.6667 3.33398 16.2917 3.33398 15.8333V14.1667C3.33398 13.7083 3.70898 13.3333 4.16732 13.3333C4.62565 13.3333 5.00065 13.7083 5.00065 14.1667Z"
          fill={fill}
        />
      </mask>
    </Icon>
  );
};

export default IconExport;
